var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('span',{staticClass:"font-weight-bold text-primary cursor-pointer",on:{"click":_vm.showDetailOrders}},[_vm._v("\n\t\t\t"+_vm._s(("#" + (_vm.data.order_id)))+"\n\t\t")])])])}
var staticRenderFns = []

export { render, staticRenderFns }